// @flow
import _ from 'lodash';
import url from 'url';
import window from 'window';

const getQuery = () => url.parse(window.location.href, true).query;

export class QueryWorker {
	static ifIs (byName: string, callback: Function) {
		if (_.get(getQuery(), byName)) {
			callback();
		}
	}

	static byValue (name: string, callback: (string) => void) {
		const queryValue = _.get(getQuery(), name);

		if (queryValue) {
			callback(queryValue);
		}
	}
}
